import { render, staticRenderFns } from "./ChartWrap.vue?vue&type=template&id=156ac90b&scoped=true"
import script from "./ChartWrap.vue?vue&type=script&lang=js"
export * from "./ChartWrap.vue?vue&type=script&lang=js"
import style0 from "./ChartWrap.vue?vue&type=style&index=0&id=156ac90b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ac90b",
  null
  
)

export default component.exports